import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useBowserNavigation = (popFunc:any = null, pushFunc:any = null, replaceFunc:any = null, isBlock = false) => {
    const history = useHistory();
    const unlistenRef = useRef(null);


    useEffect(() => {
        if (!isBlock) {
            unlistenRef.current = history.listen((location, action) => {
                if (action === 'POP') {
                    popFunc && popFunc();
                } else if (action === 'PUSH') {
                    pushFunc && pushFunc();
                } else if (action === 'REPLACE') {
                    replaceFunc && replaceFunc();
                }
            });
        } else {
            // @ts-ignore
            unlistenRef.current = history.block((location, action) => {
                if (action === 'POP') {
                    popFunc && popFunc();

                    return false;
                }

                return true;
            });
        }

        return () => {
            stopListening();
        };
    }, []);


    const stopListening = () => {
        if (unlistenRef.current) {
            // @ts-ignore
            unlistenRef.current();
            unlistenRef.current = null;
        }
    };

    return {
    };

};

export default useBowserNavigation;
